import { render, staticRenderFns } from "./mainMessageForm.vue?vue&type=template&id=bb1d74a4&scoped=true&"
import script from "./mainMessageForm.vue?vue&type=script&lang=js&"
export * from "./mainMessageForm.vue?vue&type=script&lang=js&"
import style0 from "./mainMessageForm.vue?vue&type=style&index=0&id=bb1d74a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1d74a4",
  null
  
)

export default component.exports